export default __webpack_public_path__ + "static/challenge-9b37985c67d1b83b78b145b65299cf7e.webp";